import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'
import { RichText } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { Item } from './Item'

export function BusInfo() {
  const data = useCMSPageField('PDP.PracticalInformation')
  const busInformation = data?.busInformation
  const intl = useIntl()

  if (!busInformation) {
    return null
  }

  return (
    <Item
      elementDL="Bus info"
      title={intl.formatMessage({ id: 'practical_info_bus_information_title' })}
      Glyph="BusFront"
    >
      <RichText innerHTML={busInformation} />
    </Item>
  )
}
